import React from "react";
import styled from "styled-components";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import aboutMeSvg from "../assets/about.svg";
import htmlSvg from "../assets/skills/html5.svg";
import cssSvg from "../assets/skills/css.svg";
import javascriptSvg from "../assets/skills/javascript.svg";
import bootstrapSvg from "../assets/skills/bootstrap.svg";
import reactSvg from "../assets/skills/react.svg";
import sassSvg from "../assets/skills/sass.svg";
import responsiveSvg from "../assets/skills/responsive.svg";
import { v4 as uuidv4 } from "uuid";
import wave from "../assets/wave-haikei.svg";
import Wave from "./Wave";
const About = () => {
  const skillsIcons = [
    { name: htmlSvg, id: uuidv4(), title: "HTML5" },
    { name: cssSvg, id: uuidv4(), title: "CSS3" },
    { name: sassSvg, id: uuidv4(), title: "SASS" },
    { name: bootstrapSvg, id: uuidv4(), title: "BOOTSTRAP" },
    { name: responsiveSvg, id: uuidv4(), title: "RESPONSIVE DESIGN" },
    { name: javascriptSvg, id: uuidv4(), title: "JAVSCRIPT" },
    { name: reactSvg, id: uuidv4(), title: "REACT" },
  ];

  const controls = useAnimation();
  const [element, view] = useInView({ treshold: 0.5 });
  const divAnimation = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { duration: 2 } },
  };
  if (view) {
    controls.start("show");
  } else {
    controls.start("hidden");
  }
  return (
    <AboutMe id="about">
      <motion.div
        variants={divAnimation}
        initial="hidden"
        animate={controls}
        className="information-about-me"
        ref={element}
      >
        <motion.h1>
          Hello,
          <br /> I'm Raul-Cătălin
        </motion.h1>
        <motion.h2>Aspiring Web Developer.</motion.h2>
        <p>
          I am a disciplined person that likes to use Web Technologies to create
          applications. I am always looking forward to experience and learn new
          things.
        </p>
        <a href="#projects">
          <button>Check my Work</button>
        </a>
        <p>
          I'm currently building more web applications to solidify my front-end
          skills while learning about the back-end aswell.
        </p>
      </motion.div>
      <motion.div
        variants={divAnimation}
        initial="hidden"
        animate={controls}
        className="illustration"
        ref={element}
      >
        <AboutMeImg src={aboutMeSvg} alt="illustration" />
        <div className="skills">
          {skillsIcons.map((icon) => {
            return (
              <div className="skill" key={icon.id}>
                <img src={icon.name} alt={icon.name} />
                <p>{icon.title}</p>
              </div>
            );
          })}
        </div>
      </motion.div>
      <Wave />
    </AboutMe>
  );
};

export default About;

const AboutMe = styled.section`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 10rem 3rem 3rem 3rem;
  min-height: 100vh;
  color: #6c63ff;
  /* background: url("${wave}");
  background-size: cover; */
  .information-about-me {
    flex-basis: 40%;
    color: #1f2858;
    h1 {
      font-size: 3rem;
      margin-bottom: 1rem;
      color: #1f2858;
    }
    p {
      margin: 1rem 0;
      width: 70%;
    }
    button {
      margin: 1rem 0;
      height: 3rem;
      min-width: 5rem;
      font-size: 1.5rem;
      background-color: #2a52be;
      border: none;
      border-radius: 0.4rem;
      color: #fefefe;
      transition: all 0.3s ease;
      padding: 0.5rem 1rem;
      cursor: pointer;
      &:hover {
        color: #030303;
        background-color: #fefefe;
        border: 1px solid #030303;
      }
      &:focus {
        transform: scale(0.9);
      }
    }
  }

  .skills {
    padding: 1rem 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    transition: transform 0.3s ease;
    margin: 0.5rem 0;
    .skill {
      width: 4rem;
      height: 4rem;
      text-align: center;
      margin: 1rem;
      &:hover {
        transform: scale(1.1);
      }
      p {
        font-size: 0.8rem;
        padding: 0.5rem 0;
      }
      img {
        height: 2.5rem;
        width: 2.5rem;
      }
    }
  }
  @media only screen and (max-width: 1260px) {
    .information-about-me {
      p {
        width: 100%;
      }
    }
  }
  @media only screen and (max-width: 1124px) {
    padding: 8rem 1rem;
    .information-about-me {
      flex-basis: 60%;
      h1 {
        font-size: 2.5rem;
      }
    }
    .illustration {
      flex-basis: 40%;
    }
    .skills {
      .skill {
        height: 3rem;
        width: 3rem;
        p {
          font-size: 0.7rem;
        }
      }
    }
  }
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    padding: 6rem 1rem;
    .information-about-me {
      button {
        font-size: 1rem;
      }
    }
  }
`;
const AboutMeImg = styled(motion.img)`
  width: 100%;
  height: 50%;
`;
